import { dayUntil } from "./dayUntil";
import { parseShowDateTimeInstant } from "./showDates";

/** UI copy and filter labels for computed entry states (not CMS taxonomies). */
export const COMPETITION_UI = {
  LATE_ENTRIES_LABEL: "Late Entries",
  ENTRIES_CLOSED_LABEL: "Entries Closed",
};

/** True if title is the late-entries filter tag, case-insensitive (matches CMS e.g. "Late entries"). */
export function isLateEntriesTagTitle(title) {
  if (typeof title !== "string") return false;
  return title.trim().toLowerCase() === "late entries";
}

/** True if title is the entries-closed filter tag, case-insensitive (matches CMS wording/casing). */
export function isEntriesClosedTagTitle(title) {
  if (typeof title !== "string") return false;
  return title.trim().toLowerCase() === "entries closed";
}

/**
 * Show synthetic "Entries Closed" when standard + late windows have ended (cannot enter).
 * Not shown before entries open. During the late-only window, use "Late Entries" instead.
 */
export function shouldShowEntriesClosedTag(
  entriesOpen,
  entriesClose,
  lateEntriesClose
) {
  if (!entriesClose) return false;
  if (entriesOpen && dayUntil(entriesOpen)) return false;
  return !canEnterCompetition(entriesOpen, entriesClose, lateEntriesClose);
}

/** After entries_close, before late_entries_close (requires both datetimes). */
export function isLateEntriesPeriod(
  entriesClose,
  lateEntriesClose,
  now = new Date()
) {
  if (!entriesClose || !lateEntriesClose) {
    return false;
  }
  const tClose = parseShowDateTimeInstant(entriesClose)?.getTime();
  const tLate = parseShowDateTimeInstant(lateEntriesClose)?.getTime();
  if (tClose == null || tLate == null) return false;
  const tNow = now.getTime();
  return tNow > tClose && tNow < tLate;
}

/** Standard entries window or optional late window; still respects entries_open. */
export function canEnterCompetition(
  entriesOpen,
  entriesClose,
  lateEntriesClose
) {
  if (dayUntil(entriesOpen)) {
    return false;
  }
  if (dayUntil(entriesClose)) {
    return true;
  }
  if (lateEntriesClose && dayUntil(lateEntriesClose)) {
    return true;
  }
  return false;
}
